<template>
  <router-view/>
</template>

<style>
.parent::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
</style>
